import { useTranslation } from 'react-i18next';

import { Roles } from '~/data/user';
import { useSelectedEmployeeId } from '~/hooks/employee';
import { LegacyFAIcon, LegacyFAIcons } from '~/legacy-components/LegacyFAIcon';
import { LegacyMuiButton } from '~/legacy-components/LegacyForms';
import { LegacyHeadingWithActions } from '~/legacy-components/LegacyLayout';
import { LoadingView } from '~/scenes/PortalViews/components/LoadingView';
import { employeeModulesAccessRoles } from '~/scenes/PortalViews/Views/EmployeeViews/data';

import { EmergencyContactEditMode } from './components/EmergencyContactEditMode';
import { EmergencyContactReadMode } from './components/EmergencyContactReadMode';
import { useEmergencyContact } from './useEmergencyContact';

export const EmergencyContact = () => {
  const {
    empData,
    register,
    errors,
    onSubmit,
    readMode,
    setReadMode,
    deleteContact,
    handleFormReset,
    isLoading,
  } = useEmergencyContact();
  const { t } = useTranslation();
  const {
    isSelectedEmployeeLoggedInUser,
    selectedEmployeeDetails: { hasRoleAccessOverEmployee },
  } = useSelectedEmployeeId();

  const restrictEdit =
    hasRoleAccessOverEmployee(
      [Roles.MANAGER, Roles.DEPUTY_MANAGER],
      employeeModulesAccessRoles.people.all,
    ) && !isSelectedEmployeeLoggedInUser;

  if (isLoading) {
    return <LoadingView />;
  }

  return (
    <>
      <LegacyHeadingWithActions heading={t('laEme')}>
        {!readMode ? (
          <>
            <LegacyMuiButton
              onClick={deleteContact}
              startIcon={<LegacyFAIcon FAIcon={LegacyFAIcons.Delete} />}
            >
              {t('laClear')}
            </LegacyMuiButton>
            <LegacyMuiButton
              onClick={onSubmit}
              startIcon={<LegacyFAIcon FAIcon={LegacyFAIcons.Save} />}
            >
              {t('laSave')}
            </LegacyMuiButton>
            <LegacyMuiButton
              onClick={() => handleFormReset(false)}
              startIcon={<LegacyFAIcon FAIcon={LegacyFAIcons.Close} />}
            >
              {t('laCancel')}
            </LegacyMuiButton>
          </>
        ) : (
          <>
            {!restrictEdit && (
              <LegacyMuiButton
                onClick={() => setReadMode(false)}
                startIcon={<LegacyFAIcon FAIcon={LegacyFAIcons.Edit} />}
              >
                {t('laEdit')}
              </LegacyMuiButton>
            )}
          </>
        )}
      </LegacyHeadingWithActions>
      {readMode ? (
        <EmergencyContactReadMode data={empData} />
      ) : (
        <EmergencyContactEditMode
          data={empData}
          register={register}
          errors={errors}
        />
      )}
    </>
  );
};
